// SP-2b — React Query hooks over the self-scoped staff UI flags
// (GET/POST /api/me/ui-flags). `useUiFlags` is the read the FirstRunTour
// gates on; `useStampUiFlag` stamps a flag key and invalidates the read.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { uiFlagsApi } from "@/api/uiFlagsApi";
import { uiFlagsKeys } from "./uiFlagsKeys";

export function useUiFlags() {
  return useQuery({
    queryKey: uiFlagsKeys.list(),
    queryFn: () => uiFlagsApi.list(),
  });
}

export function useStampUiFlag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => uiFlagsApi.stamp(key),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: uiFlagsKeys.all });
    },
  });
}
